<template>
    <LsInfoRow
        class="ls-info-row-quote-pricing"
        :left-image="require('./assets/pricing.svg')"
        label="Price Per Service"
        :value="rowValue"
    >
        <img
            v-if="isManualPrice && quoteLoading"
            class="ls-info-row-quote-pricing--spinner"
            :src="require('../../assets/spinner.svg')"
            test-id="quote-loading"
        />
        <v-popover v-else-if="isManualPrice && hasManualPrice" test-id="manual-price-pop-over">
            <img :src="require('../../assets/info.svg')" />
            <template slot="popover">
                <div class="ls-info-row-quote-pricing--popover">
                    <div>
                        <span
                            class="ls-info-row-quote-pricing--heading"
                            test-id="manual-price-original-values"
                            >{{
                                `Original${acceptedHeading === 'Original' ? ' (Accepted)' : ''}`
                            }}</span
                        >
                    </div>
                    <div>
                        <span>Provider Payout:</span>
                        <span test-id="manual-price-original-values">{{
                            manualPricing.payout | currency
                        }}</span>
                    </div>
                    <div>
                        <span>LawnStarter Commission:</span>
                        <span test-id="manual-price-original-values">{{
                            manualPricing.commission
                        }}</span>
                    </div>
                    <div>
                        <span>LawnStarter Revenue:</span>
                        <span test-id="manual-price-original-values">{{
                            manualPricing.revenue | currency
                        }}</span>
                    </div>
                    <div class="ls-info-row-quote-pricing--popover-hr" />
                    <div class="ls-info-row-quote-pricing--popover-price">
                        <span>Customer's Price</span>
                        <span test-id="manual-price-original-values">{{
                            manualPricing.customerPrice | currency
                        }}</span>
                    </div>
                </div>

                <div v-if="hasBackup" class="ls-info-row-quote-pricing--popover">
                    <div>
                        <span
                            class="ls-info-row-quote-pricing--heading backup"
                            test-id="manual-price-backup-values"
                            >{{
                                `Backup${acceptedHeading === 'Backup' ? ' (Accepted)' : ''}`
                            }}</span
                        >
                    </div>
                    <div>
                        <span>Provider Payout:</span>
                        <span test-id="manual-price-backup-values">{{
                            manualPricing.backupPayout | currency
                        }}</span>
                    </div>
                    <div>
                        <span>LawnStarter Commission:</span>
                        <span test-id="manual-price-backup-values">{{
                            manualPricing.backupCommission
                        }}</span>
                    </div>
                    <div>
                        <span>LawnStarter Revenue:</span>
                        <span test-id="manual-price-backup-values">{{
                            manualPricing.backupRevenue | currency
                        }}</span>
                    </div>
                    <div class="ls-info-row-quote-pricing--popover-hr" />
                    <div class="ls-info-row-quote-pricing--popover-price">
                        <span>Total</span>
                        <span test-id="manual-price-backup-values">{{
                            manualPricing.backupPrice | currency
                        }}</span>
                    </div>
                </div>
            </template>
        </v-popover>
        <v-popover v-else-if="!isManualPrice && isPriced" test-id="pop-over">
            <img :src="require('../../assets/info.svg')" />
            <template slot="popover">
                <div class="ls-info-row-quote-pricing--popover">
                    <div>
                        <span
                            class="ls-info-row-quote-pricing--heading"
                            test-id="original-values"
                            >{{
                                `Original${priceAccepted === 'original' ? ' (Accepted)' : ''}`
                            }}</span
                        >
                    </div>
                    <div>
                        <span>Contractor Payout:</span>
                        <span test-id="original-values">{{ pricingInfo.payout | currency }}</span>
                    </div>
                    <div v-if="pricingInfo.commission">
                        <span>LawnStarter Commission:</span>
                        <span test-id="original-values">{{ pricingInfo.commission }}</span>
                    </div>
                    <div>
                        <span>LawnStarter Revenue:</span>
                        <span test-id="original-values">{{ pricingInfo.revenue | currency }}</span>
                    </div>
                    <div>
                        <span>Tax:</span>
                        <span test-id="original-values">{{ schedule.tax_amount | currency }}</span>
                    </div>
                    <div class="ls-info-row-quote-pricing--popover-hr" />
                    <div class="ls-info-row-quote-pricing--popover-price">
                        <span>Customer's Price</span>
                        <span test-id="original-values">{{ pricingInfo.amount | currency }}</span>
                    </div>
                </div>

                <div v-if="pricingInfo.amount_backup" class="ls-info-row-quote-pricing--popover">
                    <div>
                        <span
                            class="ls-info-row-quote-pricing--heading backup"
                            test-id="backup-values"
                            >{{ `Backup${priceAccepted === 'backup' ? ' (Accepted)' : ''}` }}</span
                        >
                    </div>
                    <div>
                        <span>Contractor Payout:</span>
                        <span test-id="backup-values">{{
                            pricingInfo.payout_backup | currency
                        }}</span>
                    </div>
                    <div v-if="pricingInfo.commission_backup">
                        <span>LawnStarter Commission:</span>
                        <span test-id="backup-values">{{ pricingInfo.commission_backup }}</span>
                    </div>
                    <div>
                        <span>LawnStarter Revenue:</span>
                        <span test-id="backup-values">{{
                            pricingInfo.revenue_backup | currency
                        }}</span>
                    </div>
                    <div>
                        <span>Tax:</span>
                        <span test-id="backup-values">{{ schedule.tax_amount | currency }}</span>
                    </div>
                    <div class="ls-info-row-quote-pricing--popover-hr" />

                    <div class="ls-info-row-quote-pricing--popover-price">
                        <span>Total</span>
                        <span test-id="backup-values">{{
                            pricingInfo.amount_backup | currency
                        }}</span>
                    </div>
                </div>
            </template>
        </v-popover>
    </LsInfoRow>
</template>

<script>
import VueTypes from 'vue-types';
import { lsFilters } from 'ls-vue-common';
import _ from 'lodash';
import LsInfoRow from '../LsInfoRow/LsInfoRow.vue';

const MANUAL_PRICE = 'manual_price';
const CENTS_PER_DOLLAR = 100;
// Matches the `currency` filter's own placeholder.
const EMPTY_DISPLAY = '- - - -';

export default {
    name: 'LsInfoRowQuotePricing',
    components: {
        LsInfoRow,
    },
    props: {
        schedule: VueTypes.shape({
            tax_amount: VueTypes.number.isRequired,
            service: VueTypes.shape({
                price_type: VueTypes.oneOfType([VueTypes.string, VueTypes.oneOfType([null])]),
            }).loose,
            manualquote: VueTypes.shape({
                price: VueTypes.oneOfType([
                    VueTypes.shape({
                        accepted: VueTypes.oneOfType([
                            VueTypes.oneOf(['original', 'backup']),
                            VueTypes.oneOfType([null]),
                        ]),
                        payout: VueTypes.integer,
                        payout_backup: VueTypes.integer,
                        amount: VueTypes.integer,
                        amount_backup: VueTypes.integer,
                    }).loose,
                    VueTypes.oneOfType([null]),
                ]),
            }).loose,
        }).isRequired.loose,
        quote: VueTypes.oneOfType([
            VueTypes.shape({
                acceptedType: VueTypes.oneOfType([
                    VueTypes.oneOf(['STANDARD', 'BACKUP']),
                    VueTypes.oneOfType([null]),
                ]),
                customerPrice: VueTypes.integer,
                backupPrice: VueTypes.integer,
                payout: VueTypes.integer,
                backupPayout: VueTypes.integer,
            }).loose,
            VueTypes.oneOfType([null]),
        ]).def(null),
        quoteLoading: VueTypes.bool.def(false),
    },
    computed: {
        isManualPrice() {
            return _.get(this.schedule, 'service.price_type') === MANUAL_PRICE;
        },
        rowValue() {
            if (this.isManualPrice) {
                if (this.quoteLoading) {
                    return EMPTY_DISPLAY;
                }
                return this.hasManualPrice ? this.manualPriceValue : 'N/A';
            }

            return this.isPriced ? this.value : 'N/A';
        },
        hasManualPrice() {
            return !_.isNil(_.get(this.quote, 'customerPrice'));
        },
        manualPriceValue() {
            const { customerPrice, backupPrice } = this.manualPricing;
            const original = lsFilters.currency({ amount: customerPrice });
            const backup = lsFilters.currency({ amount: backupPrice });

            // The accepted side is the price the customer pays, so the row states it alone.
            // Both sides stay in the popover. A null `acceptedType` means undecided.
            if (this.acceptedHeading) {
                return this.acceptedHeading === 'Backup' ? backup : original;
            }

            return `${original} (O) ${this.hasBackup ? ', ' + backup + ' (B)' : ''}`;
        },
        manualPricing() {
            const { customerPrice, backupPrice, payout, backupPayout } = this.quote;
            const standard = this.manualSide({ price: customerPrice, payout });
            const backup = this.manualSide({ price: backupPrice, payout: backupPayout });

            return {
                payout: standard.payout,
                customerPrice: standard.price,
                revenue: standard.revenue,
                commission: standard.commission,
                backupPayout: backup.payout,
                backupPrice: backup.price,
                backupRevenue: backup.revenue,
                backupCommission: backup.commission,
            };
        },
        hasBackup() {
            return !_.isNil(_.get(this.quote, 'backupPrice'));
        },
        acceptedHeading() {
            return { STANDARD: 'Original', BACKUP: 'Backup' }[_.get(this.quote, 'acceptedType')];
        },
        value() {
            const { price } = this.schedule.manualquote;
            const originalPrice = lsFilters.currency({
                amount: price.amount,
            });

            const backupPrice = lsFilters.currency({
                amount: price.amount_backup,
            });

            return `${originalPrice} (O) ${price.amount_backup ? ', ' + backupPrice + ' (B)' : ''}`;
        },
        isPriced() {
            return _.get(this.schedule.manualquote, 'price');
        },
        pricingInfo() {
            const {
                payout,
                payout_backup,
                amount,
                amount_backup,
            } = this.schedule.manualquote.price;

            return {
                payout,
                payout_backup,
                amount,
                amount_backup,
                revenue: amount - payout,
                commission: this.commission({ commission: amount - payout, total: amount }),
                revenue_backup: amount_backup - payout_backup,
                commission_backup: this.commission({
                    commission: amount_backup - payout_backup,
                    total: amount_backup,
                }),
            };
        },
        priceAccepted() {
            return this.schedule.manualquote.price.accepted;
        },
    },
    methods: {
        commission({ commission, total }) {
            return `${((commission / total) * 100).toFixed(2)}%`;
        },
        toDollars(cents) {
            return _.isNil(cents) ? null : cents / CENTS_PER_DOLLAR;
        },
        manualSide({ price, payout }) {
            // Subtracting a null would state the whole customer price as LawnStarter's.
            const isDerivable = !_.isNil(price) && !_.isNil(payout);
            // Both fields arrive in cents; divide by 100 once, on the displayed value.
            const revenue = isDerivable ? price - payout : null;

            return {
                price: this.toDollars(price),
                payout: this.toDollars(payout),
                revenue: this.toDollars(revenue),
                commission: isDerivable
                    ? this.commission({ commission: revenue, total: price })
                    : EMPTY_DISPLAY,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-info-row-quote-pricing--popover {
    width: 240px;
    div {
        display: flex;
        justify-content: space-between;
        font-weight: $medium;
        span {
            color: $secondary-dark;
        }
    }
    div:not(:last-child) {
        margin-bottom: 5px;
    }
}

.ls-info-row-quote-pricing--heading {
    font-weight: $bold;
    margin-bottom: 10px;

    &.backup {
        margin-top: 30px;
    }
}

.ls-info-row-quote-pricing--popover-hr {
    height: 1px;
    width: 240px;
    background-color: $secondary-light;
    margin: 10px 0 15px 0 !important;
}

.ls-info-row-quote-pricing--spinner {
    width: 16px;
    height: 16px;
    animation: rotation 2s infinite linear;

    @keyframes rotation {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(359deg);
        }
    }
}

.ls-info-row-quote-pricing--popover-price {
    > span:not(:last-child) {
        font-weight: $bold !important;
    }
}
</style>
